// eslint-disable-next-line
import React, { Fragment } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { ArcaField } from '../../../code/ArcaField';
import { ArcaPageFieldState } from '../../../code/ArcaPageFieldState';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { InputField } from '../Fields/InputField';
import { ArcaHttpClientPrice } from '../../../code/ArcaHttpClientPrice';
import { ArcaPrice } from '../../../code/Types/ArcaPrice';
import { StatusBar } from '../StatusBar';
import { ArcaDate } from '../../../code/Types/ArcaDate';

export class PriceEditPanel extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            formState: this.buildFields(),
            isVisible: this.props.isVisible,
            message: '',
            isError: false
        };
    }

    render() {
        let {  message, isError } = this.state;
        let { price } = this.props;

        return (
            <Fragment>
                <Modal isOpen={true}>
                    <ModalBody>
                        <h2 className='centerText'>Edit price - {price.Name}</h2> {this.state.formState?.Fields.map((f, k) =>
                            <InputField
                                label={f.FieldLabel}
                                fieldname={f.FieldName}
                                key={f.FieldName}
                                regularExpression={f.Validation}
                                warnText='Invalid format'
                                fieldType={f.FieldType}
                                mandatory={f.IsMandatory}
                                disabled={!f.IsEnabled}
                                value={f.Value}
                                onUpdate={this.onUpdate.bind(this)}
                                fieldValid={f.IsValid}
                                prependWidth={'200px'}
                                description={f.Description}
                            />
                        )}
                        <StatusBar message={message} isError={isError} />
                        <ArcaLink text='Commit change' onClick={() => this.commitChange()} />
                        <ArcaLink text='Cancel' onClick={this.props.onCancel} />
                    </ModalBody>
                </Modal>
            </Fragment>
        );
    }

    async commitChange() {

        let { formState } = this.state;
        let { price } = this.props;

        const newPrice = new ArcaPrice();

        newPrice.ActivityType = price.ActivityType
        newPrice.Id = 0
        newPrice.Name = price.Name
        newPrice.Currency = price.Currency
        newPrice.Value = parseFloat(formState.GetField('Value').Value)
        newPrice.StartDate = new ArcaDate(new Date(formState.GetField('Start').Value))
        newPrice.EndDate = price.EndDate

        if (newPrice.Value === price.Value) {
            this.setState({
                isError: true,
                message: 'You must declare a new price for the change to be committed'
            })
            return;
        }
        if (newPrice.StartDate.IsSameDate(price.StartDate)) {
            this.setState({
                isError: true,
                message: 'You must declare a new start date for the change to be committed'
            })
            return;
        }

        await ArcaHttpClientPrice.SetPricesAsync(newPrice,
            () => this.setState({ message: 'The new price has been saved' }),
            (msg) => alert(msg)
        )
    }

    onUpdate(value, isValid, fieldName) {

        this.state.formState.GetField(fieldName).Value = value ?? '';

        this.setState({
            formState: this.state.formState,
            Fields: this.state.formState.Fields,
        });
    }

    buildFields() {
        let { price } = this.props;

        var formState = new ArcaPageFieldState();

        formState.AddField(new ArcaField("Code", "ActivityType", price.ActivityType, true, true, 'select', 'ActivityType', '', false));
        formState.AddField(new ArcaField("Activity", "Name", price.Name, true, true, 'select', 'ActivityType', '', false));
        formState.AddField(new ArcaField("Currency", "Currency", price.Currency, true, true, 'text', 'none', '', false));
        formState.AddField(new ArcaField("Value", "Value", price.Value, true, true, 'text', 'currency'));

        formState.AddField(new ArcaField("Start", "Start", price.StartDate.ToISODateString, true, true, 'date'));
        formState.AddField(new ArcaField("End", "End", price.EndDate.ToISODateString, true, true, 'date', 'none', '', false));

        return formState;
    }
}